import { ReadMoreHtml } from "@/components/read-more/ReadMoreHtml";
import { SupportedLocale } from "@/i18n";
import { formatTextWithColon } from "@/lib/utils";
import { MergedDisplayData } from "./types";

interface ArtworkOverviewProps {
  displayData: MergedDisplayData;
  locale: SupportedLocale;
  itemType: "ARTWORK" | "PHOTO_MASTER" | "TIRAGE" | "SCULPTURE";
  t: (key: string, options?: any) => string;
  overviewSummaryCalculated: string;
  isPhotoModuleEnabled?: boolean;
}

export function ArtworkOverview({
  displayData,
  locale,
  itemType,
  t,
  overviewSummaryCalculated,
  isPhotoModuleEnabled = true,
}: ArtworkOverviewProps) {
  return (
    <div className="mb-1">
      <div className="font-normal text-sm">
        <div
          dangerouslySetInnerHTML={{
            __html: overviewSummaryCalculated,
          }}
          className="subpixel-antialiased"
        />
      </div>
      <div className="my-1 subpixel-antialiased">
        {displayData?.oeuvresDescriptionSousTitrePublished === true &&
          displayData?.oeuvresDescriptionSousTitre && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionSousTitre"),
                locale,
                displayData.oeuvresDescriptionSousTitre,
              )}
            </p>
          )}
        {displayData?.oeuvresDescriptionAutreTitrePublished === true &&
          displayData?.oeuvresDescriptionAutreTitre && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionAutreTitre"),
                locale,
                displayData.oeuvresDescriptionAutreTitre,
              )}
            </p>
          )}
        {displayData?.oeuvresDescriptionAncienTitrePublished === true &&
          displayData?.oeuvresDescriptionAncienTitre?.trim() && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionAncienTitre"),
                locale,
                displayData.oeuvresDescriptionAncienTitre.trim(),
              )}
            </p>
          )}
        {displayData?.oeuvresInformationAutreNumeroPublished === true &&
          displayData?.oeuvresDescriptionNumeroAutre?.trim() && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionNumeroAutre"),
                locale,
                displayData.oeuvresDescriptionNumeroAutre.trim(),
              )}
            </p>
          )}
        {displayData?.oeuvresInformationAncienNumeroPublished === true &&
          displayData?.oeuvresInformationAncienNumero?.trim() && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresInformationAncienNumero"),
                locale,
                displayData.oeuvresInformationAncienNumero.trim(),
              )}
            </p>
          )}
        {displayData?.oeuvresDescriptionNumeroDInventairePublished === true &&
          displayData?.oeuvresDescriptionNumeroDInventaire?.trim() && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionNumeroDInventaire"),
                locale,
                displayData.oeuvresDescriptionNumeroDInventaire.trim(),
              )}
            </p>
          )}
        {displayData?.oeuvresDescriptionReferencePublished === true &&
          displayData?.oeuvresDescriptionReference && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresDescriptionReference"),
                locale,
                displayData.oeuvresDescriptionReference,
              )}
            </p>
          )}
        {isPhotoModuleEnabled &&
          displayData?.oeuvresPhotoProjectDescriptionPublished === true &&
          displayData?.oeuvresPhotoProjectDescription?.trim() && (
            <p className="font-normal text-sm">
              {formatTextWithColon(
                t("oeuvresPhotoProjectDescription"),
                locale,
                displayData.oeuvresPhotoProjectDescription.trim(),
              )}
            </p>
          )}
      </div>
      {/* For ARTWORK (not PHOTO_MASTER, not TIRAGE): always show public notes if available */}
      {itemType !== "PHOTO_MASTER" &&
        itemType !== "TIRAGE" &&
        itemType !== "SCULPTURE" &&
        displayData?.oeuvresValidationRemarquesPubliquesMultilingual?.[
          locale
        ] && (
          <div className="my-1 mt-4 flex flex-col gap-4 font-medium text-sm subpixel-antialiased">
            {displayData?.oeuvresValidationRemarquesPubliquesLabelPublished !==
              false && t("singleArtworkSubtitlePublicNote", { count: 0 })}
            <ReadMoreHtml
              html={
                displayData?.oeuvresValidationRemarquesPubliquesMultilingual[
                  locale
                ]
              }
              locale={locale}
              className="font-normal text-sm subpixel-antialiased"
            />
          </div>
        )}
    </div>
  );
}
